module.exports = __webpack_public_path__ + "static/media/02-14.760264b2.png";